module.exports = __webpack_public_path__ + "img/psychological_renbao_03.5454dea3.jpg";